import { z } from 'zod'
import { baseModelShape } from '../baseModel'

// Notification types from backend
export const notificationTypes = {
  QR_CODE_DONATION_RECEIVED: 'qr_code_donation_received',
}

// Source types from backend
export const sourceTypes = {
  DONATION: 'donation',
}

// Base notification shape matching backend serializer
export const notificationShape = {
  ...baseModelShape,
  notificationType: z.enum([notificationTypes.QR_CODE_DONATION_RECEIVED]),
  sourceType: z.enum([sourceTypes.DONATION]),
  readStatus: z.boolean(),
}

// Update notification shape (for marking as read)
export const notificationUpdateShape = {
  id: z.string().uuid(),
  readStatus: z.boolean(),
}
